// extracted by mini-css-extract-plugin
export default {"container":"style_container__dGV9d","configWrapper":"style_configWrapper__tiqw7","config":"style_config__8SnpT","header":"style_header__w8L6A","content":"style_content__2of8S"};